import { createNode } from '@glueapp/graph-types';

export const LogToConsole = createNode({
    id: 'Log to Console',
    name: 'Log to Console',
    description: 'A block to log a value to the console with',
    aiDescription:
        'Logs a value to the console and passes it through unchanged. Connect any value to the "Input" port (generic); the "Output" port returns the same value. Useful for debugging.',
    category: 'Logging',
    color: '#7d898f',
    integration: undefined,
    inPorts: {
        Input: {
            kind: 'generic',
            identifier: 'T',
        },
    },
    outPorts: {
        Output: { kind: 'generic', identifier: 'T' },
    },
    execute: function (input) {
        const inputValue = input.inPorts.Input;
        console.log(inputValue);
        return { output: { Output: inputValue } };
    },
});
